"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 16 16" id=icon-pound-16><path d="M13 13H6.24c.89-1.12 1.35-2.09 1.5-3H11c.55 0 1-.45 1-1s-.45-1-1-1H7.54c-.294-.807-.828-1.505-1.1-2.32C5.932 4.176 6.985 3 8.5 3c1.344 0 2.029.795 2.6 1.95.25.49.85.69 1.34.45.49-.25.69-.85.45-1.34-.91-1.82-2.284-3.05-4.39-3.05-2.868 0-4.876 2.542-3.95 5.32.22.66.56 1.25.79 1.68H3c-.55 0-1 .45-1 1s.45 1 1 1h2.7c-.21.7-.82 1.71-2.4 3.29-.19.19-.3.453-.3.72 0 .54.462.97.99.97H13c.55 0 1-.45 1-1s-.45-1-1-1V13Z"></path></symbol>';
}
